const { forEach } = require("lodash");

const tabs = document.querySelectorAll('.m-videos-filters__tabs a');
const select = document.getElementById('video-filter-select');
const videosContainer = document.getElementById('videos-container')
const videos = document.querySelectorAll('.m-videos__item');

function initTabs(tabs, select) {

	function init() {
		addEventListeners();
		getActiveCategoryFromUrl();
	}

	function addEventListeners() {
		tabs.forEach( function(tab) {
			tab.addEventListener('click', clickTab);
		});

		select.addEventListener('change', changeSelect);
	}

	function clickTab(e) {
		e.preventDefault();

		const tab = e.target;
		setActiveCategory(tab.dataset.videoProduct);
	}

	function changeSelect(e) {
		setActiveCategory(e.target.value);
	}

	function setActiveCategory(product, showLoading = true) {
		// Clear active product
		tabs.forEach( function(tab) {
			if ( tab.classList.contains('active') ) {
				tab.classList.remove('active');
			}
		});

		// Set active product
		tabs.forEach( function(tab) {
			if ( tab.dataset.videoProduct == product ) {
				tab.classList.add('active');
			}
		});

		setActiveCategoryUrl(product);

		filterVideos(product, showLoading);
	}

	function setActiveCategoryUrl(product) {
		if ( product == 'alles' ) {
			window.history.replaceState(null, '', window.location.href.split("#")[0]);
		} else {
			window.history.replaceState(null, '', window.location.href.split("#")[0] + '#' + product);
		}
	}

	function getActiveCategoryFromUrl() {
		if ( window.location.hash ) {
			setActiveCategory( window.location.hash.replace('#', ''), false );
		}
	}

	function filterVideos(product, showLoading = true) {
		let loadingTime = 0;

		if ( showLoading ) {
			loadingTime = 500;
			videosContainer.classList.add('loading');
		}
	
		// Fake loading just because
		setTimeout( function() {
			videosContainer.classList.remove('loading');

			videos.forEach( function(video) {
				if ( product == 'alles' ) {
					video.classList.remove('hide');
				} else if ( video.dataset.videoProduct == product ) {
					video.classList.remove('hide');
				} else {
					video.classList.add('hide');
				}
			});
		}, loadingTime);
	}

	init();
}

if ( tabs && select ) {
	initTabs(tabs, select);
}